import { createAction, props } from '@ngrx/store';
import { ICO2Bottle } from 'app/models/co2-bottle';

export const clearAllItems = createAction('[DalHelper] Clear All CO2 Bottles');
export const loadItems = createAction('[CO2 Page] Load CO2 Bottles', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsFailure = createAction('[CO2 API] Load CO2 Bottles Failure', props<{ error: any }>());
export const loadItemsSuccess = createAction('[CO2 API] Load CO2 Bottles Success', props<{ items: ICO2Bottle[] }>());

export const updateItem = createAction('[CO2 Detail Page] Update CO2 Bottle', props<{ item: ICO2Bottle }>());
export const updateItemSuccess = createAction('[CO2 API] Update CO2 Bottle Success', props<{ item: ICO2Bottle }>());
export const updateItemFailure = createAction('[CO2 API] Update CO2 Bottle Failure', props<{ error: any }>());

export const addItem = createAction('[CO2 Detail Page] Add CO2 Bottle', props<{ id: string, item: ICO2Bottle }>());
export const addItemSuccess = createAction('[CO2 API] Add CO2 Bottle Success', props<{ item: ICO2Bottle }>());
export const addItemFailure = createAction('[CO2 API] Add CO2 Bottle Failure', props<{ error: any }>());

export const deleteItem = createAction('[CO2 Detail Page] Delete CO2 Bottle', props<{ id: string }>());
export const deleteItemSuccess = createAction('[CO2 API] Delete CO2 Bottle Success');
export const deleteItemFailure = createAction('[CO2 API] Delete CO2 Bottle Failure', props<{ error: any }>());

export const setItem = createAction('[CO2 Detail Page] Set Selected Item', props<{ id: string }>());
export const setItemAndNavigate = createAction('[CO2 Detail Page] Set Selected Item And Navigate', props<{ id: string }>());
export const setItemFromListPage = createAction('[CO2 List Page] Set Selected Item', props<{ id: string }>());

export const softUpdate = createAction('[CO2 API] Soft Update CO2 Bottle', props<{ id: string, data: any, uid: string }>());
export const softUpdateSuccess = createAction('[CO2 API] Soft Update CO2 Bottle Success', props<{ id: string, data: any }>());
export const softUpdateFailure = createAction('[CO2 API] Soft Update CO2 Bottle Failure', props<{ error: any }>());
